<button class="button-copy" (click)="copy()">
    <i class="pi pi-copy icon"></i>
       {{buttonText}}
    <div class="btn-overlay"></div>
    <span
        class="message-copy"
        [ngClass]="{'message-copy-show': showCopyMessage}">{{"BUTTON_COPY.COPIED" | translate}}
    </span>
</button>
